import { useSelector } from 'react-redux';
import { RootState } from '../../store/store';
import LogoWebp from '../../assets/img/vm-logo-196.webp';
import { getSiteLogoUrl } from '../../utils/site-logo';

export default function Loader() {
  const { isLoading, isSettingsLoading } = useSelector(
    (state: RootState) => state.globalLoading
  );
  const { navigation } = useSelector((state: RootState) => state.landingPage);
  const logoUrl = getSiteLogoUrl(navigation?.logo);
  const useBundledLogo = logoUrl === LogoWebp;
  return (
    <>
      {/* Add "d-flex" to show and "d-none" to hide the loader */}
      <div
        className={`pageLoader pointer-events-none ${isLoading || isSettingsLoading ? 'd-flex' : 'd-none'}`}
      >
        <picture>
          {useBundledLogo && <source srcSet={LogoWebp} type="image/webp" />}
          <img
            src={logoUrl}
            alt="logo"
            width="98"
            height="76"
            decoding="async"
          />
        </picture>
        <div className="progress-bar">
          <div className="progress-bar__bar"></div>
        </div>
      </div>
    </>
  );
}
